import React, { useState } from "react"
import { DropdownButton, Dropdown } from "react-bootstrap"
import styles from "./SizeDropdown.module.scss"

const SizeDropdown = ({ sizes, onSelectSize }) => {
  const [activeDropdown, activeDropdownUpdater] = useState(undefined)
  const [oneSizeProduct, oneSizeProductUpdater] = useState(
    sizes.length === 1 && sizes[0].size === "ONE SIZE"
  )

  return (
    <div className={styles.container}>
      {!oneSizeProduct ? ( // if product is one size only render oneSize
        <DropdownButton
          id="dropdown-basic-button"
          variant="secondary"
          title={activeDropdown ? activeDropdown : "Select Size"}
          size="sm"
          onSelect={function(size) {
            activeDropdownUpdater(size)
            onSelectSize(size)
          }}
        >
          {sizes.map(size => (
            <Dropdown.Item
              key={size.size}
              active={activeDropdown === size.size ? activeDropdown : false}
              eventKey={size.size}
            >
              {size.size}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      ) : (
        "One Size"
      )}
    </div>
  )
}

export default SizeDropdown
